interface SVGWrapperProps {
	viewBox?: string;
	width?: string;
	height?: string;
	className?: string;
	children: React.ReactNode; // ReactNode is a type that accepts anything that can be rendered in React, such as a string, a number, an element, or a fragment.
}

const SVGWrapper: React.FC<SVGWrapperProps> = ({ children, ...props }) => {
	return (
		<svg shapeRendering="crispEdges" {...props}>
			{children}
		</svg>
	);
};

export default SVGWrapper;
